import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        pointsMeMerId: '',    // pointsMe商家ID
        lotteryCode: '',    // 抽奖code
        loginBeforeRouter: '',
        activityId: '',    // 平台抽奖活动ID
        joinkuMerId: '',   // joinku商家ID
        memberQrcode: '',   // 会员卡链接
        memberCardId: '',   // 会员卡ID
        menuId: '',   // 菜单ID
        allergenIds: [],   // 过敏源ID
    },
    mutations: {
        // 保存抽奖信息
        saveLotteryInfo (state, obj) {
            state.pointsMeMerId = obj.merchantId
            state.lotteryCode = obj.code
        },
        // 保存登录之前路由
        saveLoginBeforeRouter (state, str) {
            state.loginBeforeRouter = str
        },
        // 保存平台活动ID
        saveActivityId (state, str) {
            state.activityId = str
        },
        // 保存会员商家
        saveMemberInfo (state, obj) {
            state.joinkuMerId = obj.merchantId
            state.memberQrcode = obj.url
        },
        // 保存会员卡ID
        saveMemberCardId (state, str) {
            state.memberCardId = str
        },
        // 保存菜单ID
        saveMenuId (state, str) {
            state.menuId = str
        },
        // 保存过敏源ID
        saveAllergenIds (state, arr) {
            state.allergenIds = arr
        },
    },
    actions: {},
    modules: {
    
    },
    // 数据的持久化处理
    plugins: [
        createPersistedState({
            // 存储方式：localStorage、sessionStorage、cookies
            // storage: window.cookies, // 存储到cookie
            storage: window.sessionStorage, // 存储到sessionStorage
            // 如果不写默认存储到localStorage
            // 存储的 key 的key值
            key: "webStore",
            reducer(state) {
                // 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
                return { ...state };
            }
        })
    ]
});
